import { render, staticRenderFns } from "./EvaluatePeriodicKidsClassDialog.vue?vue&type=template&id=015ea20e&scoped=true"
import script from "./EvaluatePeriodicKidsClassDialog.vue?vue&type=script&lang=js"
export * from "./EvaluatePeriodicKidsClassDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluatePeriodicKidsClassDialog.vue?vue&type=style&index=0&id=015ea20e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ea20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015ea20e')) {
      api.createRecord('015ea20e', component.options)
    } else {
      api.reload('015ea20e', component.options)
    }
    module.hot.accept("./EvaluatePeriodicKidsClassDialog.vue?vue&type=template&id=015ea20e&scoped=true", function () {
      api.rerender('015ea20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/EvaluatePeriodicKidsClassDialog.vue"
export default component.exports